import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import LazyLoad from 'react-lazyload';
import { kebabCase } from 'lodash';
import {
  Box,
  BoxContent,
  BoxFooter,
  Link,
  Heading,
  Paragraph,
  IconSVG,
  Button,
  BackgroundImage,
  SectionHeader,
} from 'components';
import './BlogSlider.scss';

class BlogSlider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sliderSettings: {
        className: 'blog-slider',
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        speed: 0,
        infinite: true,
        draggable: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        useTransform: false,
        touchMove: true,
        fade: true,
      },
    };
  }

  renderSlides = () => {
    const { data, theme } = this.props;
    const colors =
      theme === 'light'
        ? {
            primary: 'white',
            secondary: 'mine-shaft',
            text: 'black',
            line: 'black',
          }
        : {
            primary: 'mine-shaft',
            secondary: 'white',
            text: 'white',
            line: 'golden-dream',
          };

    return data.map((item, index) => (
      <div
        className={'blog-slider__slide-container w-container--side-left'}
        key={`culture-slide-${index}`}
      >
        <div
          className={`blog-slider__slide-wrapper ${item.color &&
            `blog-slider__slide-wrapper--${item.color}`}
          }`}
        >
          <LazyLoad once offset={200} height={720}>
            <div className={'blog-slider__image'}>
              <BackgroundImage
                src={item.background}
                additionalClass={'blog-slider__slide'}
              />
              {data.length > 1 && (
                <div
                  className={`blog-slider__navigation blog-slider__navigation--${
                    colors.secondary
                  }`}
                >
                  <div
                    id={'blog-slider-prev'}
                    role={'presentation'}
                    onClick={() => this.slider.slickPrev()}
                  >
                    <IconSVG name={'arrow-left'} color={colors.primary} />
                  </div>
                  <div
                    id={'blog-slider-next'}
                    role={'presentation'}
                    onClick={() => this.slider.slickNext()}
                  >
                    <IconSVG name={'arrow-right'} color={colors.primary} />
                  </div>
                </div>
              )}
            </div>
          </LazyLoad>
          {item.link ? (
            <Link
              to={item.link}
              id={`box-${kebabCase(item.content.toLowerCase())}`}
              arrow
            >
              <div
                className={`blog-slider__item blog-slider__item--${
                  colors.primary
                }`}
              >
                <Box
                  additionalClass={'blog-slider__box'}
                  backgroundColor={colors.primary}
                >
                  <BoxContent type={'slider'}>
                    <Heading
                      size={'big'}
                      color={colors.text}
                      type={3}
                      additionalClass={'blog-slider__box-headline'}
                    >
                      {item.content}
                    </Heading>
                    <Paragraph
                      size={'medium'}
                      color={colors.text}
                      additionalClass={'text--light'}
                      spaced
                    >
                      {item.description}
                    </Paragraph>
                  </BoxContent>
                  <BoxFooter>
                    <Button order={'secondary'} color={colors.secondary}>
                      Case study
                    </Button>
                  </BoxFooter>
                </Box>
              </div>
            </Link>
          ) : (
            <div
              className={`blog-slider__item blog-slider__item--${
                colors.primary
              }`}
            >
              <Box
                additionalClass={'blog-slider__box'}
                backgroundColor={colors.primary}
              >
                <BoxContent type={'slider'}>
                  <SectionHeader
                    size={'medium'}
                    color={colors.text}
                    headingType={3}
                    lineColor={colors.line}
                    additionalClass={'blog-slider__box-headline'}
                  >
                    {item.content}
                  </SectionHeader>
                  <Paragraph
                    size={'medium'}
                    color={colors.text}
                    additionalClass={'text--light'}
                    spaced
                  >
                    {item.description}
                  </Paragraph>
                </BoxContent>
              </Box>
            </div>
          )}
        </div>
      </div>
    ));
  };

  render() {
    const { sliderSettings } = this.state;

    return (
      <Slider
        ref={slider => {
          this.slider = slider;
        }}
        {...sliderSettings}
      >
        {this.renderSlides()}
      </Slider>
    );
  }
}

BlogSlider.defaultProps = {
  data: [],
  theme: 'light',
};

BlogSlider.propTypes = {
  data: PropTypes.array,
  theme: PropTypes.string,
};

export default BlogSlider;
